import { Checkbox } from "../../ui/checkbox";
import { UploadTile } from "../UploadTile";
import { useWizard } from "../WizardContext";
import { config } from "../../../lib/config";

const consentLink = "inline-block py-1 font-semibold text-[#7A0016] underline decoration-[#D4AF37] decoration-2 underline-offset-2 hover:text-[#C59B27]";

function Consent() {
  const { data, set, errors } = useWizard();
  const error = errors["agreement.consent"];
  return (
    <div data-error={error ? "true" : undefined} className="rounded-xl border border-[#D4AF37]/40 bg-[#FAFAF7] p-4">
      <label className="flex cursor-pointer items-start gap-3 text-sm text-[#2C2424]">
        <Checkbox className="mt-0.5" checked={data.agreement.consent} onCheckedChange={(v) => set("agreement", "consent", v === true)} data-testid="field-agreement-consent" />
        <span>
          I confirm the information provided is true and I agree to the{" "}
          <a href={config.termsUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} data-testid="consent-terms-link" className={consentLink}>Terms and Conditions</a> and{" "}
          <a href={config.privacyUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} data-testid="consent-privacy-link" className={consentLink}>Privacy Policy</a>.
        </span>
      </label>
      {error && <p data-testid="error-agreement-consent" className="mt-2 text-xs font-medium text-[#A31828]">{error}</p>}
    </div>
  );
}

export default function StepUploads() {
  const { mode } = useWizard();
  return (
    <div className="space-y-7">
      <p className="text-xs text-[#8C6A6C]">Photos are compressed in your browser before upload. All files stay private until approved by our team.</p>
      <UploadTile field="profile_photo" label="Profile photo" kind="image" bucket="profile-photos" folder="photos" required testId="upload-profile-photo" />
      <UploadTile field="gallery" label="Gallery photos (up to 3)" kind="image" bucket="profile-photos" folder="photos" multiple max={3} testId="upload-gallery" />
      <UploadTile field="id_proof" label="ID proof (Aadhaar, PAN, Passport, Voter ID) (optional)" kind="document" bucket="id-documents" folder="id-proof" testId="upload-id-proof" />
      {mode !== "admin" && <Consent />}
    </div>
  );
}
